import * as React from "react";
import {
  ContractMinimalFragment,
  ContractTemplateMinimalFragment,
} from "../../graphql/fragments";
import useTranslations from "../../hooks/useTranslations";
import { Link, Tooltip } from "../wombat-ui";

type ContractPlateProps = {
  contractTemplate: ContractTemplateMinimalFragment;
  contract: ContractMinimalFragment;
  madId: string;
};

export const ContractPlate: React.FC<ContractPlateProps> = ({
  contractTemplate,
  contract,
  madId,
}) => {
  const t = useTranslations();

  return (
    <Tooltip label={contractTemplate.title}>
      <div
        className="flex items-center justify-between h-12 px-4 py-3 my-2 space-x-4 rounded bg-light-0"
      >
        {
          contract ? (
            <a
              href={contract ? contract.document : '#'}
              id={`downloadContract${contractTemplate.title}`}
            >
              <p className="text-xs truncate text-primary-800 overflow-ellipsis">
                {contractTemplate.title}
              </p>
            </a>
          ) : (
            <>
              <p className="text-xs truncate text-primary-800 overflow-ellipsis">
                {contractTemplate.title}
              </p>
              <Link
                to={`/contracts/${contractTemplate.id}/mads/${madId}/edit`}
                id={`addContract${contractTemplate.title}`}
                className="text-xs"
              >
                {t("contracts.add")}
              </Link>
            </>
          )
        }
      </div>
    </Tooltip>
  );
}
